import { Parts, Part } from './parts';
import { Shipment, ShippingDocuments } from './shipment';
import { Files, File } from './files';
import { QualityApproval } from './qualityApproval';
import { MoldReceiving } from './moldReceiving';
import { MoldMaintenance} from './moldMaintenance';
import { MoldRelease } from './moldRelease';
import { Vendor } from './vendor';

class CustomPropTypes {
  static Shipment = Shipment;
  static ShippingDocuments = ShippingDocuments;
  static QualityApproval = QualityApproval;
  static Parts = Parts;
  static Part = Part;
  static Files = Files;
  static File = File;
  static MoldReceiving = MoldReceiving;
  static MoldMaintenance = MoldMaintenance;
  static MoldRelease = MoldRelease;
  static Vendor = Vendor;
}

export default CustomPropTypes;
